import * as React from 'react';
import * as styles from './ReliableBlock.css';
import { ArticleParagraph1, ArticleHeading3, useDeviceType, TDeviceType, ModalWindow, Button } from '@cian/ui-kit';
import { Section } from '../Section';
import { IButtonProps } from '@cian/ui-kit/button/types';
import { useEventCallback, useToggleState } from '@cian/react-utils';
import { ModalContent } from './components/ModalContent';
import logo from './assets/logo.svg';

interface IReliableBlockProps {
  onClick(): void;
}

const BUTTON_PROPS: Record<TDeviceType, IButtonProps> = {
  desktop: {
    size: 'XS',
  },
  tablet: {
    size: 'M',
  },
  phone: {
    size: 'M',
    fullWidth: true,
  },
};

export const ReliableBlock: React.FC<IReliableBlockProps> = ({ onClick }) => {
  const deviceType = useDeviceType();

  const { state: isOpen, toggle } = useToggleState();

  const handleClick = useEventCallback(() => {
    onClick();
    toggle();
  });

  return (
    <Section dataName="ReliableBlock">
      <div className={styles['container']}>
        <div className={styles['image-container']}>
          <img src={logo} />
        </div>
        <div className={styles['title']}>
          <ArticleHeading3>Надежная компания</ArticleHeading3>
        </div>
        <div className={styles['description']}>
          <ArticleParagraph1>Эксперты Федерации ИЖС подтвердили опыт и репутацию компании</ArticleParagraph1>
        </div>
        <div className={styles['button']}>
          <Button {...BUTTON_PROPS[deviceType]} theme="fill_white_primary" onClick={handleClick}>
            О методе проверки
          </Button>
        </div>
      </div>
      {isOpen && (
        <ModalWindow
          open
          title="Надежная компания"
          onClose={toggle}
          maxWidth={928}
          fixed={deviceType === 'phone'}
          content={<ModalContent />}
          footer={
            <Button size="L" theme="fill_primary" fullWidth={deviceType !== 'desktop'} onClick={toggle}>
              Хорошо
            </Button>
          }
        />
      )}
    </Section>
  );
};
